// SanitizedLink.jsx
import React, { useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import getToObject from '../resource/getToObject.js';

export const SanitizedLink = forwardRef(
  ({ to: propsTo = '', ...restProps }, ref) => {
    const to = useMemo(
      () => getToObject({ to: propsTo, shouldFilterSearch: true }),
      [propsTo]
    );
    return <Link ref={ref} to={to} {...restProps} />;
  }
);

SanitizedLink.displayName = 'SanitizedLink';

SanitizedLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default SanitizedLink;
